
export function isSmall () {
  return document.body.offsetWidth < 960;
}

export function isMedium () {
  return document.body.offsetWidth >= 960 && document.body.offsetWidth < 1280;
}

export function isLarge () {
  return document.body.offsetWidth >= 1280 && document.body.offsetWidth < 1470;
}

export function isXLarge () {
  return document.body.offsetWidth >= 1470;
}

export function isXXLarge () {
  return document.body.offsetWidth >= 1880;
}

export function hasTouchSupport () {
  const supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
  return supportsTouch;
}

export function isMacintosh () {
  return navigator.userAgent.indexOf('Mac') > -1;
}

export function isWindows () {
  return navigator.userAgent.indexOf('Win') > -1;
}
